export function attachmentsFromFiles(files = []) {
  return files
    .map((file) => ({
      id: file?.docId ?? file?.documentId ?? file?.id ?? null,
      name: file?.name ?? file?.fileName ?? file?.filename ?? '',
      type: file?.type ?? file?.mimeType ?? '',
    }))
    .filter((file) => file.id || file.name)
}

export function docScopeFromFiles(files = []) {
  return [
    ...new Set(
      files
        .map((file) => file?.docId ?? file?.documentId ?? file?.id)
        .filter((id) => typeof id === 'string' && id.trim()),
    ),
  ]
}
